import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { getBasicObjectTypeLayer, getAllObjectsLayer } from "../../../../widgets/map/mapFeatures/layers";
import { showMapTooltip } from "../../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { useDispatch } from "react-redux";
import { setMapTooltipIsVisible } from "../../../../stateManagement/reducers/MapTooltipSlice";
import { getObjectsOnWMSLayer } from "../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { MapOverlayWidget } from "../../../../widgets/map/mapAddons/mapOverlayWidget";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";
import { useMapURLParams } from "../../../../hooks/map/useMapParams";
import { MapName } from "../../../../stateManagement/reducers/maps/actions";
import { useMapSlice } from "../../../../stateManagement/hooks/useMapSlice";
import { buildAdditionalMapFilteredLayer } from "../../../../widgets/map/mapFeatures/utils/buildAdditionalMapFilteredLayer";
import { configureAllObjectsLayerHideExpression } from "../../../../widgets/map/mapFeatures/utils/configureAllObjectsLayerHideExpression";

export function MapWaysideLandLots() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const currentConfig = useMemo(() => getItemWebStorage('currentConfig'), []);
    const { menuAdditionalItems } = currentConfig ?? {};
    const menuItem = menuAdditionalItems.find((menuItem: any) => menuItem?.item?.type === `map.${mapName}`)?.item
    const mapState = useMapSlice(mapName)
    const { appliedFilters, mapFiltersExpressions }: any = mapState ?? {};
    const objectTypesToHideOnAllObjectsLayer = ["roadLandLots", "adjacentLandLots", "waysides"]
    const allObjectsLayerHideExpression = configureAllObjectsLayerHideExpression(objectTypesToHideOnAllObjectsLayer)

    const roadsLayer = getAllObjectsLayer(allObjectsLayerHideExpression)
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, title } = menuItem ?? {};
        if (title) {
            setMapTitle(`Карта «${title}»`);
        }
        if (!mapLayer) {
            navigate('/app/error');
            return;
        }
    }, [menuItem]);

    useEffect(() => {
        const layer = buildAdditionalMapFilteredLayer(
            menuItem,
            appliedFilters,
            mapFiltersExpressions,
            currentConfig
        )
        setAdditionalLayers([layer])
    }, [menuItem, appliedFilters, mapFiltersExpressions])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnWMSLayer(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget
                    additionalLayers={additionalLayers}
                    mapEventHandlers={mapEventHandlers}
                    permanentLayers={permanentLayers}
                />
                <MapOverlayWidget />
            </div>
        </>
    )
}
